Fselecao<template>

     <!-- Raiz da aplicação Vuetify -->
    <v-app> 

        <!-- Área principal da aplicação -->
        <v-main> 
        
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >      
                
                <v-toolbar-title class="white--text">Cadastro Equipamentos</v-toolbar-title> 
                <v-spacer />

            </v-toolbar>

            <!-- Conteúdo com espaçamento -->
            <v-container fluid class="pa-4">

                <!-- Card que agrupa elementos do formulário  -->
                <v-card class="pa-4" style="width: 100%; top: 60px">

                    <v-form ref="formCadastroEquipamento" v-model="validaCadastroEquipamentos">
                    
                        <v-row>
                        
                            <!-- Seleção tipo equipamento -->
                            <v-col cols="12" md="8">
                                <v-select
                                    v-model="dadosCadastroEquipamentos.idTipoEquipamento"
                                    :items="dadosCadastroEquipamentos.listaTipoEquipamento"
                                    item-title="title"
                                    item-value="value"
                                    return-object
                                    label="Selecione Tipo Equipamento"
                                    clearable
                                    @update:model-value="manipuladorSelecaoEquipamento"
                                    :disabled="idEquipamentoRecebido !== 0"
                                >                    
                                </v-select>
                            </v-col>

                             <!-- Coluna para o código de barras -->
                            <v-col cols="12" md="4" class="d-flex justify-center">
                                                                    
                                <!-- Botão de Imprimir -->
                                <v-btn
                                    color="primary"
                                    :disabled="!valorCodigoBarras"
                                    @click="imprimirCodigoBarras"
                                    prepend-icon="mdi-printer"
                                    class="mr-2"
                                    height="50"
                                >
                                    Imprimir Código
                                </v-btn>
                                
                                <!-- SVG onde o código será renderizado -->
                                <svg v-if="valorCodigoBarras" ref="barcodeSvg" class="barcode-svg"></svg>
                                
                                <!-- Mensagem quando não há código -->
                                <div v-else class="no-barcode">
                                    <v-icon size="48" color="grey">mdi-barcode-off</v-icon>
                                    <p class="text-caption mt-2">Nenhum Código Gerado</p>
                                </div>
                                
                            </v-col>                        
                            
                        </v-row>
                        
                        <v-row>

                            <v-col cols="12" md="4">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.numeroSerie"
                                    label="Número Série" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    @keyup="montaNomeEquipamento"
                                    v-uppercase
                                />
                            </v-col>
                        
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.equipamento"
                                    label="Equipamento" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                            
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.modelo"
                                    label="Modelo" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                            
                        </v-row>
                        
                        <v-row>

                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dadosCadastroEquipamentos.idFabricante"
                                    :items="dadosCadastroEquipamentos.listaFabricantes"
                                    item-title="title"
                                    item-value="value"
                                    label="Selecione Fabricante"
                                    clearable
                                    
                                >                    
                                </v-select>

                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.numeroPatrimonio"
                                    label="Nº Patrimonio" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                        </v-row>


                        <v-row>
                            
                            <v-col cols="12" md="6">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.armario"
                                    label="Nº Armário" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field 
                                    v-model="dadosCadastroEquipamentos.secao"
                                    label="Seção" 
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>

                        </v-row>

                        <v-row>

                            <v-col cols="12" md="12">
                                <v-textarea
                                    v-model="dadosCadastroEquipamentos.observacoes"
                                    label="Observações" 
                                    v-uppercase
                                    :rows="1"
                                    auto-grow
                                    no-resize
                                />
                            </v-col>

                        </v-row>

                        <v-row>

                            <v-col cols="12" md="12">
                                <v-select
                                    v-model="dadosCadastroEquipamentos.idAvarias"
                                    :items="dadosCadastroEquipamentos.listaAvarias"
                                    item-title="title"
                                    item-value="value"
                                    label="Selecione Última Avaria"
                                    clearable                                    
                                >                    
                                </v-select>
                            </v-col>

                        </v-row>

                        <v-row>

                            <v-col cols="12" md="2" class="d-flex align-center">
                                <v-switch
                                    :label="dadosCadastroEquipamentos.ativo ? 'Ativo' : 'Inativo'"
                                    :color="dadosCadastroEquipamentos.ativo ? 'blue' : 'white'"
                                    v-model="dadosCadastroEquipamentos.ativo"
                                />
                            </v-col>

                        </v-row>                         
                        
                    </v-form>

                    <v-card-actions class="flex-wrap">
                        
                        <v-spacer />

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: orange; color: white;"
                            @click="funcaoRetornar()"
                            >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: #2196F3; color: white;"
                            @click="validaSalvarEquipamento('salvar')"
                            >
                            <v-icon left color="white">mdi-update</v-icon>
                            Salvar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid orange; color: orange;"
                            @click="validaSalvarEquipamento('salvar-retornar')"
                            >
                            <v-icon left color="orange">mdi-update</v-icon>
                            Salvar e Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                            @click="validaSalvarEquipamento('salvar-novo')"
                            >
                            <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                            Salvar e Novo
                        </v-btn>

                    </v-card-actions>
                </v-card>

            </v-container>

        </v-main>

    </v-app>

</template>

<script setup>

    /* DEPENDENCIAS E VARIAVEIS COMUNS */
    
    // Importa funcionalidades do Vue
    import { ref, onMounted, onBeforeUnmount, nextTick, watch  } from 'vue'
    
    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o componente do editor de texto rico
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa useRouter para acessar parâmetros de rota
    import { useRouter } from 'vue-router'

    // Importa useRoute para acessar parâmetros de rota
    import { useRoute } from 'vue-router'

    // Importa componente para gerar código de barras
    import JsBarcode from 'jsbarcode'

    // Importa o canal de comunicação entre componentes
    import { channel } from '@/utils/channel'

    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Acessa o ID da empresa via query param
    const router = useRouter();

    // Acessa o ID da empresa via query param
    const route = useRoute(); 
    
    
    /* VARIAVEIS DO FORMULÁRIO */
    
    // Variável para armazenar o ID da empresa (0 para nova empresa)
    const idEmpresaRecebido = ref(0)
    const idSetorRecebido = ref(0)
    const idEquipamentoRecebido = ref(0)

    // Referência do formulário de cadastro de empresa
    const formCadastroEquipamento = ref(null)

    // Validação do formulário de ramo de atividade
    const validaCadastroEquipamentos = ref(false)

    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)

    // Ref para o objeto completo do tipo de equipamento
    const tipoEquipamentoSelecionado = ref(null);

    // Busca o modo da barra lateral vindo da lista
    modoBarraLateral.value = route.query.modoBarraLateral    

    // Dados do ramo de atividade
    const dadosCadastroEquipamentos = ref({
        idFabricante: null,
        listaFabricantes: [],
        idTipoEquipamento: null,
        listaTipoEquipamento: [],
        idCadastrou: 0,
        idAvarias: null,
        listaAvarias: [],
        numeroSerie: '',
        equipamento: '',
        modelo: '',
        numeroPatrimonio: '',
        armario: '',
        secao: '',
        observacoes: '',
        siglaEquipamento: '',
        idUltimoKit: 0,
        ativo: true
    })

    // Regras de validação
    const rules = {
        required: v => !!v || 'Campo obrigatório'
    }

    // 1. Referência para o elemento SVG
    const barcodeSvg = ref(null)

    // 3. Variável que armazena o valor do código de barras
    const valorCodigoBarras = ref('')

    // 4. Configurações FIXAS do código de barras (ajuste conforme sua necessidade)
    const configuracaoCodigoBarras = {
        format: "CODE128",      // Tipo: CODE128, CODE39, EAN13, etc.
        width: 2,              // Largura das barras
        height: 30,           // Altura das barras
        displayValue: true,    // Mostrar o texto abaixo
        fontSize: 16,          // Tamanho da fonte do texto
        background: "#ffffff", // Cor de fundo
        lineColor: "#000000",  // Cor das barras
        margin: 0,
        textMargin: 0
    }

    // Busca idEmpresa, idSertor e idEquipamento vindos da lista de equipamentos
    idEmpresaRecebido.value = Number(route.query.idEmpresa) || 0;
    idSetorRecebido.value = Number(route.query.idSetor) || 0;
    idEquipamentoRecebido.value = Number(route.query.idEquipamento) || 0;

    // Função para lidar com a mudança
    function manipuladorSelecaoEquipamento(item) {

        if (item) {
            
            // Salva o objeto completo
            tipoEquipamentoSelecionado.value = item;
            
            // Salva também o ID separadamente (se necessário para API)
            dadosCadastroEquipamentos.value.idTipoEquipamento = item.value;
            
            // Atualiza sigla no formulário se quiser
            dadosCadastroEquipamentos.value.siglaEquipamento = item.sigla;

            // Se houver especificação de número de série, monta o nome do equipamento
            if (dadosCadastroEquipamentos.numeroSerie != ''){
                montaNomeEquipamento()
            }

        } else {

            tipoEquipamentoSelecionado.value = null;
            dadosCadastroEquipamentos.value.idTipoEquipamento = null;
            dadosCadastroEquipamentos.value.siglaEquipamento = '';
        }
    }

    // Limpa campos do cadastro de empresas
    function limpadadosCadastroEquipamentos(){

        dadosCadastroEquipamentos.value = {
            idFabricante: null,
            listaFabricantes: [],
            idTipoEquipamento: null,
            listaTipoEquipamento: [],
            idCadastrou: 0,
            idAvarias: null,
            listaAvarias: [],
            numeroSerie: '',
            equipamento: '',
            modelo: '',
            numeroPatrimonio: '',
            armario: '',
            secao: '',
            observacoes: '',
            siglaEquipamento: '',
            idUltimoKit: 0,
            ativo: true
        }

        // Limpa id de ramo de atividade recebido da lista
        idEquipamentoRecebido.value = 0
    }

    // Função que lê o tamanho da barra no localStorage e aplica na 
    function ajustaBarraPretaTopo(){
        
        if (localStorage.getItem('tamanhoBarraLaterar') == 'true'){
            modoBarraLateral.value = true
        } else{
            modoBarraLateral.value = false
        }
    }

    // Retorna para a lista de empresas
    function funcaoRetornar() {
        channel.postMessage('atualizar-lista')
        window.close()
    }

    // Regra personalizada para validar campos
    async function validaSalvarEquipamento(funcaoRetorno) {
        
        // Valida o formulário de empresa
        const isValid = await formCadastroEquipamento.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados da empresa
            salvardadosCadastroEquipamentos(funcaoRetorno)

        } else {            
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');
        }
    }    

    // Esta função salva ou edita os dados de uma empresa
    async function salvardadosCadastroEquipamentos(funcaoRetorno) {

        try {
            
            const corpoRequisicao = {
                idEmpresa: idEmpresaRecebido.value,
                idSetor: idSetorRecebido.value,
                idFabricante: dadosCadastroEquipamentos.value.idFabricante,
                idTipoEquipamento: dadosCadastroEquipamentos.value.idTipoEquipamento,
                idCadastrou: loginStore.idColaborador,
                idAvarias: dadosCadastroEquipamentos.value.idAvarias ,
                numeroSerie: dadosCadastroEquipamentos.value.numeroSerie,
                equipamento: dadosCadastroEquipamentos.value.equipamento,
                modelo: dadosCadastroEquipamentos.value.modelo,
                numeroPatrimonio: dadosCadastroEquipamentos.value.numeroPatrimonio,
                armario: dadosCadastroEquipamentos.value.armario,
                secao: dadosCadastroEquipamentos.value.secao,
                observacoes: dadosCadastroEquipamentos.value.observacoes,
                idUltimoKit: dadosCadastroEquipamentos.value.idUltimoKit,                    
                ativo: dadosCadastroEquipamentos.value.ativo
            };

            // Busca o ID da empresa para saber se é inclusão ou edição
            const {data: resposta } = await axios.post(`${API_BASE_URL}/operacao/salvarEquipamentoEmpresa/${idEquipamentoRecebido.value}`, corpoRequisicao, 
            {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Atualiza o idEmpresa com o valor retornado da API
            idEquipamentoRecebido.value = resposta.idEquipamento;

            // Exibe mensagem de sucesso
            snackbar.trigger('Equipamento Salvo Com Sucesso.', 'success');

            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                funcaoRetornar()
            } else {
                limpadadosCadastroEquipamentos()
            }

        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    } 

    // Carrega tipos de equipamentos, fabricantes e tipos de avarias
    async function carregaTipoFabricanteDefeitos() {
        
        try {

            // Busca todos os tipos de equipamentos
            var { data } = await axios.get(`${API_BASE_URL}/administracao/carregaListaTipoEquipamento`,{
                params: { 
                    ordenacaoPor: 'nome',  
                    direcaoOrdenacao: 'asc',
                    paginaAtual: 1,
                    itensPorPagina: -1
                }, headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que mesmo sem dados retorne um array
            const dataTiposEquipamentos = data.data || []

            // Garante que temos um array válido de tipos de chamados
            const tipoEquipamento = Array.isArray(dataTiposEquipamentos) 
                ? dataTiposEquipamentos
                : dataTiposEquipamentos || []
            
            // Filtra tipos de chamados ativos
            const tiposEquipamentosAtivos = tipoEquipamento.filter(tipoEquipamento => tipoEquipamento.ativo == 1)

            // Carrega os tipos de chamados no formato que o v-select precisa
            dadosCadastroEquipamentos.value.listaTipoEquipamento = tiposEquipamentosAtivos.map(tipo => ({
                value: tipo.idTipoEquipamento,
                title: tipo.nome,
                sigla: tipo.sigla
            }))            
            
            // Busca todos fabricantes cadastrados
            var { data } = await axios.get(`${API_BASE_URL}/administracao/carregaListaFabricantes`,{
                params: { 
                    ordenacaoPor: 'nome',  
                    direcaoOrdenacao: 'asc',
                    paginaAtual: 1,
                    itensPorPagina: -1
                }, headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que mesmo sem dados retorne um array
            const dataFabricantes = data.data || []

            // Garante que temos um array válido de tipos de chamados
            const fabricantes = Array.isArray(dataFabricantes) 
                ? dataFabricantes
                : dataFabricantes || []
            
            // Filtra tipos de chamados ativos
            const fabricantesAtivos = fabricantes.filter(fabricante => fabricante.ativo == 1)

            // Carrega os tipos de chamados no formato que o v-select precisa
            dadosCadastroEquipamentos.value.listaFabricantes = fabricantesAtivos.map(tipo => ({
                value: tipo.idFabricante,
                title: tipo.nome
            })) 
        
        
            // Busca todas avarias cadastradas
            var { data } = await axios.get(`${API_BASE_URL}/administracao/carregaListaAvarias`,{
                params: { 
                    ordenacaoPor: 'nome',  
                    direcaoOrdenacao: 'asc',
                    paginaAtual: 1,
                    itensPorPagina: -1
                }, headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que mesmo sem dados retorne um array
            const dataAvarias = data.data || []

            // Garante que temos um array válido de tipos de chamados
            const avarias = Array.isArray(dataAvarias) 
                ? dataAvarias
                : dataAvarias || []
            
            // Filtra tipos de chamados ativos
            const avariasAtivas = avarias.filter(avaria => avaria.ativo == 1)

            // Carrega os tipos de chamados no formato que o v-select precisa
            dadosCadastroEquipamentos.value.listaAvarias = avariasAtivas.map(tipo => ({
                value: tipo.idAvaria,
                title: tipo.nome
            })) 

        } catch(erro){
            erroStore("Erro Carregar Equipamentos.")
        } 
    }

    // Intercepta o evento de uma tecla pressiona no campo número de série
    const montaNomeEquipamento = (event) => {

        // Monta nome do equipamento usando a sigla do equipamento e os três últimos digitos do número de séria
        if (dadosCadastroEquipamentos.value.numeroSerie != null && 
            dadosCadastroEquipamentos.value.numeroSerie != '' && 
            dadosCadastroEquipamentos.value.numeroSerie.length >= 3){

            // Monta nome do equipamento usando a sigla e os três últimos números de série
            dadosCadastroEquipamentos.value.equipamento = 
                tipoEquipamentoSelecionado.value.sigla + 
                dadosCadastroEquipamentos.value.numeroSerie.slice(-3)

            // Gera código de barras do equipamento
            gerarCodigoBarras(dadosCadastroEquipamentos.value.equipamento)
        
        } else {

            // Limpa campo equipamento
            dadosCadastroEquipamentos.value.equipamento = ''
        }
    }

    // Função para gerar código de barras
    const gerarBarcodeNoSvg = () => {

        if (!valorCodigoBarras.value || !barcodeSvg.value) return
        
        try {

            // Limpa qualquer conteúdo anterior
            barcodeSvg.value.innerHTML = ''
            
            // Gera o código de barras no elemento SVG
            JsBarcode(barcodeSvg.value, valorCodigoBarras.value, configuracaoCodigoBarras)

        } catch (erro) {
            erroStore.exibirErro("Erro Gerar Código Barras: " + erro)
        }
    }

    // Função que você vai chamar para gerar o código
    const gerarCodigoBarras = (texto) => {

        // Validação básica
        if (!texto || typeof texto !== 'string') {
            erroStore.exibirErro("Selecione Tipo Equipamento Digite Número Série")
            return
        }
    
        // Remove espaços extras
        const textoLimpo = texto.trim()
    
        if (textoLimpo === '') {
            valorCodigoBarras.value = ''
            return
        }
    
        // Atribui o valor - isso automaticamente dispara o watch acima
        valorCodigoBarras.value = textoLimpo
    }

    // FUNÇÃO PRINCIPAL DE IMPRESSÃO
    const imprimirCodigoBarras = async () => {
        
        if (!valorCodigoBarras.value) {
            erroStore.exibirErro("Selecione Tipo Equipamento Digite Número Série")
            return
        }
        
        try {

            // Aguarda renderização completa
            await nextTick()
            
            // Cria uma janela de impressão
            const conteudoImpressao = criarConteudoImpressao()
            
            // Abre a janela de impressão
            const janelaImpressao = window.open('', '_blank')
            janelaImpressao.document.write(conteudoImpressao)
            janelaImpressao.document.close()
            
            // Aguarda o carregamento e imprime
            janelaImpressao.onload = () => {
            
                janelaImpressao.focus()
                janelaImpressao.print()
            
                // Fecha a janela após impressão (opcional)
                janelaImpressao.close()
            }
            
        } catch (erro) {
            erroStore.exibirErro("Erro Imprimir Código Barras: " + erro)
        }
    }

    // Função para criar o HTML de impressão
    const criarConteudoImpressao = () => {

        return `
            <!DOCTYPE html>

            <html>

                <head>

                    <style>

                        @media print {
                            @page {
                                size: 80mm 50mm; /* Tamanho para etiqueta adesiva */
                                margin: 5mm;
                            }
                
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                width: 70mm;
                                height: 40mm;
                            }
                        }
                
                        .etiqueta {
                            width: 70mm;
                            height: 30mm;
                            padding: 5mm;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                    
                        .cabecalho {
                            text-align: center;
                            margin-bottom: 5px;
                            font-size: 10px;                        
                        }   
                
                        .barcode-container {
                            text-align: center;
                            margin: 5px 0;
                        }
                    
                        svg {
                            max-width: 100%;
                            height: auto;
                        }
                    
                    </style>

                </head>
                
                <body>
            
                    <div class="etiqueta">
                        
                        <div class="barcode-container">
                            ${barcodeSvg.value?.outerHTML || ''}
                        </div>
                    
                    </div>
                
                    <script>
                        // Fecha a janela após impressão (opcional)
                        window.onafterprint = function() {
                            setTimeout(function() {
                                window.close();
                            }, 500);
                        };
                    <\/script>

                </body>

            </html>`
    }

    // Monitora quando o valor do código muda e gera o barcode
    watch(valorCodigoBarras, () => {

        nextTick(() => {
            gerarBarcodeNoSvg()
        })
    })

    // Carrega os arrayRamosAtividade ao montar o componente
    onMounted(async () => {

        try{

            // Listener para mudanças do drawer
            const manipuladorMudancaTamanho = (data) => {

                // Salva valor emitido pelo botão de minimizar/maximizar a barra lateral
                localStorage.setItem('tamanhoBarraLaterar', data)            
                
                // Ajusta barra preta do topo do formulário
                ajustaBarraPretaTopo(data)
            }
        
            // Adiciona listener para mudanças do drawer
            emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

            // Ajusta a barra preta do topo do fomulário com o valor do localStorage
            ajustaBarraPretaTopo()

            // Carrega tipos de equipamentos, fabricantes e tipos de avarias
            await carregaTipoFabricanteDefeitos()
        
            // Aguarde um tick para garantir que as listas foram carregadas
            await nextTick();
            
            // Verifica se existe o idEmpresaRecebido para carregar os dados da empresa
            if (idEquipamentoRecebido.value != 0){

                // Chama a API para buscar os dados da empresa pelo ID
                const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaEquipamento/${idEquipamentoRecebido.value}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Busca resposta da api
                const respostaApi = data.data

                // Verifica se recebeu resposta da api
                if (respostaApi) {

                    // Preenche o formulário com os dados recebidos
                    dadosCadastroEquipamentos.value.idTipoEquipamento = respostaApi.idTipoEquipamento
                    dadosCadastroEquipamentos.value.numeroSerie = respostaApi.numeroSerie
                    dadosCadastroEquipamentos.value.equipamento = respostaApi.equipamento
                    dadosCadastroEquipamentos.value.modelo = respostaApi.modelo
                    dadosCadastroEquipamentos.value.idFabricante = respostaApi.idFabricante
                    dadosCadastroEquipamentos.value.numeroPatrimonio = respostaApi.numeroPatrimonio
                    dadosCadastroEquipamentos.value.armario = respostaApi.armario
                    dadosCadastroEquipamentos.value.secao = respostaApi.secao
                    dadosCadastroEquipamentos.value.observacoes = respostaApi.observacoes
                    dadosCadastroEquipamentos.value.idAvarias = respostaApi.idAvarias
                    dadosCadastroEquipamentos.value.ativo = respostaApi.ativo == 1 ? true : false
                    dadosCadastroEquipamentos.value.siglaEquipamento = respostaApi.sigla

                    // Busca sigla, nome e id do equipamento carregado e selecionado na lista usando o idTipoEquipamento
                    const equipEncontrado = dadosCadastroEquipamentos.value.listaTipoEquipamento.find(
                        item => item.value === respostaApi.idTipoEquipamento || item.id === respostaApi.idTipoEquipamento
                    )

                    // Salva os dados do tipo de equipamento
                    tipoEquipamentoSelecionado.value = equipEncontrado

                    // Salva os dados para gerar o código de barras
                    valorCodigoBarras.value = respostaApi.equipamento

                    if (valorCodigoBarras.value) {
                        nextTick(() => {
                            gerarBarcodeNoSvg()
                        })
                    }
                }
            }
        } catch(erro){
            erroStore.exibirErro(erro)
        }
    })

    // Rotina chamada antes de desmontar o componente
    onBeforeUnmount(() => {

        // Limpa idEquipamentoRecebido
        idEquipamentoRecebido.value = 0

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })
        
</script>

<style scoped>
    
    .barcode-wrapper {
        width: 100%;
        min-height: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
    }

    .barcode-svg {
        width: 100%;
        max-width: 300px;
        height: auto;
        background: white;
        margin-top: -20px;
        padding: 10px;
        
    }

    .no-barcode {
        text-align: center;
        color: #666;
    }

        /* Responsividade */
    @media (max-width: 960px) {
        .barcode-wrapper {
            margin-top: 16px;
        }
    }

</style>